import styled from 'styled-components';
import { useVehicleUploadTabsContext } from '../context';
import { useFormState } from 'react-final-form';
import { VEHICLE_FORM_FIELDS, VIN_FORM_FIELDS } from '../constants';

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 8px 16px 8px;
`;

const Tab = styled.div<{ $isSelected: boolean }>`
  flex: 1 1 100%;
  text-align: center;
  border-bottom: 1px solid ${props => (props.$isSelected ? '#3994DE' : '#CCCCCC')};
  padding-bottom: 8px;

  color: ${props => (props.$isSelected ? '#225A91' : '#666666')};

  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
`;

const isTabDirty = (dirtyFields: Record<string, boolean>, fields: string[]) => {
  return fields.some(field => !!dirtyFields[field]);
};

export const VehicleInfoTabs = () => {
  const { selectedTab, setSelectedTab, tabs } = useVehicleUploadTabsContext();
  const [vinInfoTab, vehicleInfoTab] = tabs;

  const state = useFormState({ subscription: { dirtyFields: true } });
  const isDirty = isTabDirty(state.dirtyFields, selectedTab === 'vin_info' ? VIN_FORM_FIELDS : VEHICLE_FORM_FIELDS);

  return (
    <Wrapper>
      <Tab
        onClick={() => {
          if (isDirty) return;
          setSelectedTab(vinInfoTab.value);
        }}
        $isSelected={selectedTab === vinInfoTab.value}
      >
        {vinInfoTab.label}
      </Tab>
      <Tab
        onClick={() => {
          if (isDirty) return;
          setSelectedTab(vehicleInfoTab.value);
        }}
        $isSelected={selectedTab === vehicleInfoTab.value}
      >
        {vehicleInfoTab.label}
      </Tab>
    </Wrapper>
  );
};
